import { render, staticRenderFns } from "./costumersClub.vue?vue&type=template&id=3b4cd7fe&"
import script from "./costumersClub.vue?vue&type=script&lang=js&"
export * from "./costumersClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports